import { useEffect, useRef, useState } from 'react';
import './HowItWorksSection.css';

const STEPS = [
  {
    number: '01',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="5" y="2" width="14" height="20" rx="2"/>
        <path d="M12 18h.01"/>
        <path d="M9 7h6M9 11h4"/>
      </svg>
    ),
    title: 'Connect Your Channels',
    desc: 'Scan a QR code to link WhatsApp with no API approval needed. Connect your Gmail inbox in one click. Your bot is online in under 5 minutes.',
    highlight: 'No approvals. No developers.',
  },
  {
    number: '02',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 2a10 10 0 1 0 10 10"/>
        <path d="M12 6v6l4 2"/>
        <path d="M20 2v4h-4"/>
        <path d="M16 2l4 4"/>
      </svg>
    ),
    title: 'Train Your AI',
    desc: 'Upload your product catalog, FAQs, pricing, and policies in plain text. Zepliq reads everything and becomes a complete expert on your business instantly.',
    highlight: 'Plain text. No code required.',
  },
  {
    number: '03',
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
      </svg>
    ),
    title: 'Watch It Grow',
    desc: 'Your AI handles every conversation 24/7. Leads captured, orders confirmed, customers supported. Your team focuses on closing deals, not answering the same questions.',
    highlight: '24/7 automation. Zero effort.',
  },
];

export default function HowItWorksSection() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section className="hiw section" ref={ref}>
      <div className="container">

        <div className={`hiw__header ${visible ? 'hiw__header--visible' : ''}`}>
          <span className="badge badge-brand">How It Works</span>
          <h2 className="display-lg hiw__title">
            From zero to automated<br />
            <span className="gradient-text">in three steps.</span>
          </h2>
          <p className="text-lg hiw__sub">
            No technical setup. No waiting. Most businesses go live the same day they sign up.
          </p>
        </div>

        <div className="hiw__steps">
          {STEPS.map((step, i) => (
            <div
              key={step.number}
              className={`hiw__step ${visible ? 'hiw__step--visible' : ''}`}
              style={{ transitionDelay: `${0.15 + i * 0.15}s` }}
            >
              {/* Connector line */}
              {i < STEPS.length - 1 && (
                <div className="hiw__connector" aria-hidden="true">
                  <div className="hiw__connector-line" />
                  <svg className="hiw__connector-arrow" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                  </svg>
                </div>
              )}

              <div className="hiw__card">
                {/* Number */}
                <span className="hiw__number">{step.number}</span>

                {/* Icon */}
                <div className="hiw__icon-wrap">
                  <div className="hiw__icon">{step.icon}</div>
                </div>

                {/* Content */}
                <h3 className="hiw__step-title">{step.title}</h3>
                <p className="hiw__step-desc">{step.desc}</p>
                <span className="hiw__highlight">{step.highlight}</span>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
